import { __read } from "tslib";
import { createRef, useEffect, useState } from 'react';
export var useItemRefs = function (arrowKeyListNavEnabled, numberOfItems) {
    var _a = __read(useState([]), 2), itemRefs = _a[0], setItemRefs = _a[1];
    // Init array with new refs T when number of items change
    useEffect(function () {
        if (!arrowKeyListNavEnabled || itemRefs.length === numberOfItems) {
            return;
        }
        var refs = [];
        for (var i = 0; i < numberOfItems; i++) {
            refs[i] = itemRefs[i] || createRef();
        }
        setItemRefs(refs);
    }, [itemRefs, arrowKeyListNavEnabled, numberOfItems]);
    return itemRefs;
};
//# sourceMappingURL=useItemRefs.js.map